import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { License } from "../types";

interface LicensesState {
  list: License[];
  loading: boolean;
  error: string | null;
}

const initialState: LicensesState = {
  list: [],
  loading: false,
  error: null,
};

const licensesSlice = createSlice({
  name: "licenses",
  initialState,
  reducers: {
    fetchLicensesStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchLicensesSuccess(state, action: PayloadAction<License[]>) {
      state.list = action.payload;
      state.loading = false;
    },
    fetchLicensesFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    addLicense(state, action: PayloadAction<License>) {
      state.list.push(action.payload);
    },
    updateLicense(state, action: PayloadAction<License>) {
      const index = state.list.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) state.list[index] = action.payload;
    },
    removeLicense(state, action: PayloadAction<string>) {
      state.list = state.list.filter((c) => c.id !== action.payload);
    },
  },
});

export const {
  fetchLicensesStart,
  fetchLicensesSuccess,
  fetchLicensesFailure,
  addLicense,
  updateLicense,
  removeLicense,
} = licensesSlice.actions;
export default licensesSlice.reducer;
